/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
import Toasted from 'vue-toasted';
import FileSelector from 'vue-file-selector';
import VueSelectImage from 'vue-select-image'
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
import wysiwyg from "vue-wysiwyg";
import "vue-wysiwyg/dist/vueWysiwyg.css";
import Vue from 'vue'

require("./bootstrap");

window.Vue = Vue;
Vue.use(require('vue-moment'));
Vue.use(Toasted, {
    'duration':5000,
    'keepOnHover':true
});
Vue.use(FileSelector);
Vue.use(VueSelectImage)
Vue.use(VModal)
Vue.use(wysiwyg, {paragraphSeparator: 'p', hideModules: {"image": true}});

if (process.env.NODE_ENV === 'production') {
    let Bugsnag = require('@bugsnag/js')
    Bugsnag.start({
        apiKey: '194d426dee27d123697e0c58512bfd19',
        enabledReleaseStages: ['production']
    })
}

require("./materialize.min");
require("parsleyjs/dist/parsley.min.js");
require("slick-carousel/slick/slick.min.js");

require("./global");

require("./layouts/register.js");
require("./layouts/innovation-single.js");
require("./layouts/dashboard-articles.js");
require("./layouts/dashboard-innovations.js");
require("./layouts/dashboard-networks.js");
require("./layouts/network-join.js");
require("./layouts/network-vetting.js");
require("./layouts/search.js");
require("./layouts/new_search.js");
require("./layouts/home.js");
require("./layouts/dashboard-case-studies.js");
require("./layouts/speedometer.js");
require("./layouts/dashboard-sidebar.js");
require("./layouts/dashboard-application-expert.js");
require("./layouts/dashboard-application-innovation.js");

require("./components/global/notifications/Notifications.js");
require("./components/messages/Messages.js");
require("./components/global/organisationSelector/organisationSelector.js");
require("./components/network/networkMessages/NetworkMessages.js");
require("./components/network/editor/Editor.js");
require("./components/network/submitApplication/submitApplication.js");
require("./components/network/list/list.js");
require("./components/network/videoUpload/videoUpload.js");
require("./components/network/documentUpload/documentUpload.js");
require("./components/network/vetting/VettingQuestions.js");
require("./components/innovation/editor/Editor.js");
require("./components/innovation/search/AdvancedSearch.js");
require("./components/university/editor/Editor.js");
require("./components/article/editor/Editor.js");
require("./components/user/editor/Editor.js");
require("./components/article/Actions.js");
require("./components/comments/Comments.js");
require("./components/imports/Basic.js");
// require("./components/global/pricing/Pricing.js");
require("./components/global/referallLink/ReferallLink.js");
// require("./components/pricing/editiablePricing.js");
require("./components/innovation-library/LibraryGroupList.js");
require("./components/innovation-library/LibraryGroupSingle.js");
require("./components/network-group/create/Create.js");
require("./components/network-group/editor/Editor.js");
require("./components/performance-overview/performanceOverview.js");
require("./components/case-study/editor/Editor.js");
require("./components/innovation-library/LibraryListFE");
require("./components/innovation/innovation-list");
require("./components/members/members-list");
require("./components/innovation-library/libraries-list");
require("./components/university/universities-list");
require("./components/content-hub/list");
require("./components/collaborators/list");
require("./components/case-study/list");
require("./components/resources/list");

require("./components/network/create/Create.js");
require("./components/network/administration/reporting/Reporting.js");
require("./components/network/administration/applications/Applications.js");
require("./components/network/administration/pipelines/Pipelines.js");
require("./components/network/administration/vetting/Vetting.js");
require("./components/network/administration/settings/Settings.js");
require("./components/network/administration/singleApplication/Score.js");
require("./components/network/administration/singleApplication/ApprovalStatusChange.js");
require("./components/network/administration/singleApplication/ResponseStatusChange.js");
require("./components/network/administration/singleApplication/Voting.js");
require("./components/network/administration/singleApplication/Share.js");
require("./components/network/administration/singleApplication/PipelineSelectorAndHistory.js");
require("./components/network/administration/singleApplication/InternalComments.js");
require("./components/network/administration/singleApplication/CollaboratorComments.js");
require("./components/network/administration/singleApplication/Documents.js");
require("./components/network/administration/singleApplication/Tags.js");
require("./components/network/administration/versions/Versions.js");
require("./components/user/Member.js");
require("./components/user/Connections.js");
require("./components/network/administration/challengeAdmin/AdminDoughnutChart");
require("./components/calendly");

require("./onboarding/dashboard.js");
require("./onboarding/innovation-editor.js");
require("./onboarding/article-editor.js");
require("./onboarding/network-editor.js");
require("./onboarding/profile-editor.js");
require("./onboarding/university-editor.js");
require("./onboarding/account-editor.js");
require("./onboarding/vetting.js");
require("./onboarding/application-review.js");
require("./onboarding/network-administration-reporting.js");
require("./onboarding/network-administration-applications.js");
require("./onboarding/network-administration-single-application.js");
require("./onboarding/pipeline-start.js");
require("./onboarding/study-editor.js");

require("./strength.js");
require('vue-select-image/dist/vue-select-image.css')


